import { Injectable } from '@angular/core';
import { HierarchyConfig } from './configuration/keying.hierarchy.environment.config';

@Injectable({
  providedIn: 'root',
})
export class KeyingHierarchyService {
  constructor(private config: HierarchyConfig) {}
  getSampleData(): void {
    console.log(this.config.getKeyingUrl());
  }

  getKeyingUrl(): string {
    return this.config.getKeyingUrl();
  }
}
